const i18n = {
    en: {
        description: {
            start: "Your offer of",
            middle: "was accepted for",
        },
        title: "Offer Accepted",
    },
    es: {
        description: {
            start: "Tu oferta de",
            middle: "fue aceptada para",
        },
        title: "Oferta aceptada",
    },
    zh: {
        description: {
            start: "您的出价",
            middle: "已被接受",
        },
        title: "接受报价",
    },
};
export { i18n };
//# sourceMappingURL=BidAcceptedNotification.i18n.js.map